import PropTypes from "prop-types";

export const stringInput = PropTypes.shape({
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
});

export const numericInput = PropTypes.shape({
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired
});

export const boolInput = PropTypes.shape({
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired
});

export const malleable = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired
});

export const objectInput = objShape =>
  PropTypes.shape({
    value: PropTypes.shape(objShape),
    onChange: PropTypes.func.isRequired
  });

export const meta = PropTypes.shape({
  invalid: PropTypes.bool,
  touched: PropTypes.bool,
  error: PropTypes.arrayOf(PropTypes.string)
});

export const modalForm = {
  handleSubmit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  submitting: PropTypes.bool
};

export const formField = t =>
  PropTypes.shape({
    meta,
    input: t
  });



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormTypes.js